import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { useSignInForm } from "scenes/Authentication/hooks";

import { Button, Form, Layout, Loading } from "./components";

export function SignInForm({ email }) {
  const { formProps, signIn, loading, error } = useSignInForm({ email });

  if (loading) return <Loading active message="Signing you in..." />;

  return (
    <Layout errorMessage={error}>
      <Form {...formProps} onSubmit={signIn}>
        <Form.Input
          name="email"
          label="Email"
          fluid
          defaultValue={email}
          placeholder="Enter your email"
        />
        <Form.Input
          name="password"
          label="Password"
          type="password"
          fluid
          placeholder="Enter your password"
        />
        <div style={{ textAlign: "center", width: "100%" }}>
          <Link to="/v2/forgot-password">Forgot your password?</Link>
        </div>
        <Button primary fluid style={{ margin: "22px 0px" }}>
          Log In
        </Button>
        <div style={{ textAlign: "center", width: "100%" }}>
          <Link to="/v2/signup">Sign up for a free trial</Link>
        </div>
      </Form>
    </Layout>
  );
}

SignInForm.propTypes = {
  email: PropTypes.string,
};

SignInForm.defaultProps = {
  email: "",
};

export default SignInForm;
